module.exports = __webpack_public_path__ + "static/media/public_MSS.65fe761f.png";